import React, { useState } from 'react';
import { Layout } from 'antd';
import { AntBreakpoints } from 'works/legacy/lib/style-helper';
import { Sidenav } from './_sidenav';
import { Logo } from './_logo';
import { Item } from './_item';
import { Icon } from '@common/components';
import { useLocation } from '@common/hooks';

const { Sider } = Layout;

export const Sidebar = ({
  logoTo,
  selectedItem,
  children,
}: React.PropsWithChildren<{
  selectedItem: string | undefined;
  logoTo: string;
}>) => {
  const width = window.innerWidth;
  const location = useLocation();
  const isLogoLinkActive = logoTo === location.pathname;
  const [collapsed, setCollapsed] = useState(width < AntBreakpoints.sm);

  return (
    <>
      <Sider
        className="wk-sidebar"
        width="80px"
        collapsed={collapsed}
        collapsedWidth={0}
        breakpoint="sm"
        trigger={null}
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
      >
        <span className="ant-block ant-sm-dn ant-layout-sider-zero-width-trigger ant-layout-sider-zero-width-trigger-left">
          <button
            className="toggle-button"
            onClick={() => setCollapsed(!collapsed)}
          >
            <Icon icon="bars" kind="regular" size="lg" />
          </button>
        </span>
        <Logo to={logoTo} active={isLogoLinkActive} />
        <Sidenav selectedItem={selectedItem}>{children}</Sidenav>
      </Sider>
      <style jsx>{`
        :global(.wk-sidebar) {
          z-index: 3;
          position: fixed;
          height: 100vh;
        }
        :global(.wk-sidebar .toggle-button) {
          background-color: transparent;
          padding: 0;
          margin: 0;
          border: 0;
        }
        :global(.wk-sidebar .ant-layout-sider-zero-width-trigger) {
          z-index: 2;
          color: black;
          background-color: white;
        }
        :global(.wk-sidebar span.ant-layout-sider-zero-width-trigger) {
          top: 16px;
          width: auto;
        }
        :global(.wk-sidebar span.ant-layout-sider-zero-width-trigger::after) {
          z-index: -1;
        }
      `}</style>
    </>
  );
};

Sidebar.Item = Item;
